if (!customElements.get('pt-bb-packs')) {
  customElements.define('pt-bb-packs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const root = this.closest('product-info');
      const quantity = root?.querySelector('input[name="quantity"]');
      if (!quantity) return;
      const sync = () => {
        this.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === quantity.value; });
        const summary = root.querySelector('[data-pt-bb-mobile-price]');
        // The native product form remains the authority for quantity, selling plans, and cart additions.
        if (summary) {
          const unitPrice = root.querySelector('.price__sale .price-item--sale') || root.querySelector('.price__regular .price-item--regular');
          const count = quantity.value || '1';
          summary.textContent = `${unitPrice?.textContent.trim() || ''} each · ${count} ${count === '1' ? 'bottle' : 'bottles'}`;
        }
      };
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        quantity.value = event.target.value;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      }, { signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeQuantity?.();
        this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, sync);
      }
      quantity.addEventListener('change', sync, { signal });
      quantity.addEventListener('input', sync, { signal });
      const shippingLink = root.querySelector('.pt-bb-shipping-link');
      const state = root.querySelector('.stc select');
      if (state && shippingLink) {
        const syncState = () => { shippingLink.textContent = state.value ? `Shipping: ${state.value} · check` : 'Check shipping'; };
        state.addEventListener('change', syncState, { signal });
        syncState();
      }
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); this.unsubscribeQuantity?.(); }
  });
}
if (!customElements.get('pt-bb-flight')) {
  customElements.define('pt-bb-flight', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const form = this.querySelector('form');
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button');
        const status = form.querySelector('[role="status"]');
        if (button.disabled) return;
        button.disabled = true;
        status.textContent = 'Adding your three bottles…';
        try {
          const response = await fetch(`${form.action}.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Please review your selection and try again.');
          window.location.assign(window.routes?.cart_url || '/cart');
        } catch (error) {
          // Do not automatically retry an uncertain addition: customers can inspect the cart first.
          status.textContent = 'We could not confirm the addition. Please check your cart before trying again.';
          const link = document.createElement('a');
          link.href = window.routes?.cart_url || '/cart'; link.textContent = ' View cart';
          status.append(link); button.disabled = false;
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
